const SET_VISITED_SUBUNITS = 'set-visited-subunits';
const UPDATE_ALL_VISITED_SUBUNITS = 'update-all-visited-subunits';

export { SET_VISITED_SUBUNITS, UPDATE_ALL_VISITED_SUBUNITS };
